export const SHOP_FLOOR_WELCOME_BLURB_SHOWN =
  'ownable_SHOP_FLOOR_WELCOME_BLURB_SHOWN';
